import { useOrder as _useOrder } from "services/orders";

/**
 * Hook/helper to get the currently selected order
 * @returns Order
 */
export function useOrder() {
  return _useOrder();
}
